import { MutableRefObject } from "react";
import { Button } from "@mui/material";
import { useBlocker } from "react-router-dom";

export const NavigationBlocker = ({
  isDirty,
  bypassRef,
}: {
  isDirty: boolean;
  // Read live at block-time instead of relying on `isDirty` alone, which can
  // be stale for a tick after a post-save reset() + immediate navigate().
  bypassRef?: MutableRefObject<boolean>;
}) => {
  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty &&
      !bypassRef?.current &&
      currentLocation.pathname !== nextLocation.pathname
  );

  return (
    <>
      {blocker.state === "blocked" ? (
        <div
          style={{
            // center
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            position: "sticky",
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 8,
            minHeight: 120,
            paddingBottom: 12,
            paddingTop: 0,
            width: 500,
            paddingLeft: 24,
            paddingRight: 24,
            zIndex: 999,
            border: "1px solid black",
            borderRadius: 10,
            backgroundColor: "white",
          }}
        >
          <div>
            <h3>You have unsaved changes, are you sure you want to leave?</h3>
            <div style={{ display: "flex", gap: 10 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => blocker?.proceed?.()}
              >
                Proceed
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => blocker?.reset?.()}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
